
import apiClient from "../../../../../../services/apiClient";


export const personalStatisticsActions = {
  getStatisticsPersonal: async (district) => {
    let params = [];
    params.push('district=' + district);
    const linkGet = 'getStatisticsPersonal?' + params.join('&');
    
    return await apiClient.get(linkGet);
  },

  getPersonalStatisticsByKg: async (kgId) => {
    let params = [];
    params.push('id=' + kgId);
    const linkGet = 'stat_personal_kg?' + params.join('&');
    
    return await apiClient.get(linkGet);
  }
};